import React from 'react';
import { FormControl, FormLabel, Select } from '@chakra-ui/react';

const UrlTargeting = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>URL Targeting Choice</FormLabel>
        <Select
          name="actionProps.urlTargeting.choice"
          value={formik.values.actionProps.urlTargeting.choice}
          onChange={formik.handleChange}
        >
          <option value="ALL">All</option>
          <option value="SPECIFIC">Specific</option>
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Global Operator</FormLabel>
        <Select
          name="actionProps.urlTargeting.globalOperator"
          value={formik.values.actionProps.urlTargeting.globalOperator}
          onChange={formik.handleChange}
        >
          <option value="OR">OR</option>
          <option value="AND">AND</option>
        </Select>
      </FormControl>
      {/* Add dynamic list for criteria and utmParameters if needed */}
    </>
  );
};

export default UrlTargeting;